import React from "react";
import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
    const words = [
        "APPS",
        "WEBSITES",
        "INTELIGÊNCIA ARTIFICIAL",
        "AUTOMAÇÃO",
        "SISTEMAS",
        "PRODUTO DIGITAL",
    ];
    return (
        <section
            className="border-y border-white/10 py-8 md:py-10 bg-[#050505] overflow-hidden"
            data-testid="editorial-marquee"
        >
            <Marquee gradient={false} speed={35} pauseOnHover={false}>
                {words.map((w, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-14 pr-14 font-display uppercase text-[9vw] md:text-[7vw] leading-none tracking-tighter"
                    >
                        <span
                            className={
                                i % 2 === 0
                                    ? "outline-text"
                                    : "outline-text-accent"
                            }
                        >
                            {w}
                        </span>
                        <span className="text-[#00FF66] text-3xl md:text-5xl">
                            ✦
                        </span>
                    </div>
                ))}
            </Marquee>
        </section>
    );
}
